module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booleanfield"
  }, [_vm._v("\n  " + _vm._s(_vm.formattedValue) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af7e5ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldBoolean.vue
// module id = 686
// module chunks = 0